import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class PlatformLinkService {

    private platformLinkSubject = new Subject<{
        platformName: string;
        logoURL: string;
        heading: string;
        description: string;
    }>();

    platformLink$ = this.platformLinkSubject.asObservable();

    setPlatformLink(platformLink: {
        platformName: string;
        logoURL: string;
        heading: string;
        description: string;
    }): void {
        this.platformLinkSubject.next(platformLink);
    }

}
